import {
  Box,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import React, { useState } from 'react';
import TopBar from './TopBar';
import NotificationContainer from './NotificationsContainer';
import PrivacyContainer from './PrivacyContainer';
import MobileSettings from './MobileSettings';

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);

  const renderPage = () => {
    switch (activeTab) {
      case 0:
        return <NotificationContainer />;
      case 1:
        return <PrivacyContainer />;
      default:
        return null;
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 500,
          mb: 3,
          color: 'text.primary',
          textAlign: 'left',
        }}
      >
        Settings
      </Typography>
      <TopBar activeTab={activeTab} setActiveTab={setActiveTab} />
      <Box sx={{ mt: { xs: 2, md: 4 } }}>{renderPage()}</Box>
    </>
  );
};

const SettingsContainer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container
      maxWidth="xl"
      sx={{ py: { xs: 2, md: 4 }, px: { xs: 1.5, md: 3 } }}
    >
      {isMobile ? <MobileSettings /> : <Settings />}
    </Container>
  );
};

export default SettingsContainer;
